<template>
    <div class="page-wrapper">
        <div class="cg-crumb">
            <span class="item">订单管理</span>
            <em class="gap">/</em>
            <span class="item">清算列表</span>
        </div>
        <div class="cg-main-title">
            清算列表
            <div class="link-wrap">
                <button class="cg-btn" @click="toListLock">锁仓列表</button>
                <button class="cg-btn mgl-16" @click="toListOrder">下单列表</button>
            </div>
        </div>
        <div class="header-handle">
            <div class="cg-search-box">
                <el-input
                    size="mini"
                    placeholder="ID/商品名称/款号"
                    prefix-icon="el-icon-search"
                    v-model.trim="searchWords"
                    clearable
                    >
                </el-input>
                <button class="cg-btn red" @click="searchHandle">搜索</button>
            </div>
            <!-- <div class="btns">
                <button class="cg-btn red" @click="toAddGoods">新增商品</button>
                <button class="cg-btn mgl-16" @click="exportItemInfo">下载表格</button>
            </div> -->
        </div>
        <div class="table-wrap">
            <el-table
                :data="tableData"
                v-loading="loading"
                size="small"
            >
                <!-- <el-table-column
                    type="selection"
                    align="center"
                    width="55"
                >
                </el-table-column> -->
                <el-table-column
                    align="center"
                    label="序号"
                    type="index"
                    width="50"
                    :index="indexMethod"
                >
                </el-table-column>
                <el-table-column
                    prop="order_number"
                    label="清算订单号"
                    width="80"
                >   
                </el-table-column>
                <el-table-column
                    prop="mallItemFileUrl"
                    label="图片"
                    width="80"
                >
                    <template slot-scope="scope">
                        <el-image
                            style="width: 64px; height: 64px"
                            :src="scope.row.mallItemFileUrl"
                            fit="cover"
                            :preview-src-list="[scope.row.mallItemFileUrl]"
                        >
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="productName"
                    label="商品名称"
                    width="100"
                >
                </el-table-column>
                <el-table-column
                    prop="styleNumber"
                    label="款号"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="dealerName"
                    label="销售商"
                    width="70"
                >
                </el-table-column>
                <el-table-column
                    prop="orderPurchaseQuantity"
                    label="总下单数"
                    width="60"
                >
                </el-table-column>
                <el-table-column
                    prop="sumEstablishQuantity"
                    label="已核销数"
                    width="60"
                >
                </el-table-column>
                <el-table-column
                    prop="unEstablishQuantity"
                    label="未核销数"
                    width="60"
                >
                </el-table-column>
                <el-table-column
                    prop="returnQuantity"
                    label="退货数"
                    width="60"
                >
                </el-table-column>
                <el-table-column
                    prop="needPay"
                    label="总需支付额(元)"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="sumPay"
                    label="累计支付额(元)"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="amountToBeConfirmed"
                    label="待确认金额(元)"
                    width="80"
                >
                </el-table-column>
                <!-- <el-table-column
                    prop="debtMoney"
                    label="欠款(元)"
                    width="80"
                >
                </el-table-column> -->
                <el-table-column
                    prop="order_submit_time"
                    label="清算时间"
                    width="90"
                >
                </el-table-column>
                <el-table-column
                    prop="itemState"
                    label="下单状态"
                    width="100"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.order_state == 6" type="success" size="medium">清算完成</el-tag>
                        <el-tag v-else type="warning" size="medium">清算中</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="140"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button class="cg-icon-btn" @click="toClearDetail(scope.row)" type="text" size="small">查看</el-button>
                        <!-- <el-button class="cg-icon-btn" @click="toGoodsEdit(scope.row)" type="text" size="small">确认退货</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="cg-pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            
        </div>
    </div>
</template>

<script>
import { getLiquidateList } from '../../../api/supplier'
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            loading: false,
            searchWords: '',
            tableData: [],

            // 分页
            pageSize: 10,
            total: 0,
            currentPage: 1,
        }
    },
    computed: {
        ...mapGetters(['userId'])
    },
    created() {
        console.log(this.$route.query);
    },
    watch: {
        '$route': {
            handler: function (route) {
                this.pageSize = Number(this.$route.query.size) ? Number(this.$route.query.size) : 10
                this.currentPage = Number(this.$route.query.page) ? Number(this.$route.query.page) : 1
                this.searchWords = this.$route.query.search || ''
                this.getClearList();
            },
            immediate: true
        }
    },
    methods: {
        getClearList() {
            this.loading = true
            getLiquidateList({
                "supplierUserId": this.userId,
                "dealerUserId": '',
                "page": this.currentPage,
                "num": this.pageSize,
                "fuzzyQuery": this.searchWords
            }).then(res => {
                this.loading = false
                console.log('getLiquidateList', res)
                if (res.errorCode == 200) {
                    this.tableData = res.data.orderList.map(item => {
                        // 图片
                        let mallItemFileUrl
                        if (item.mallItemFileUrl) {
                            mallItemFileUrl = process.env.VUE_APP_IMG_PREV + item.mallItemFileUrl
                        } else if (item.orderPurchaseList && item.orderPurchaseList[0] && item.orderPurchaseList[0].productMainImageFile) {
                            mallItemFileUrl = process.env.VUE_APP_IMG_PREV + item.orderPurchaseList[0].productMainImageFile
                        }
                        // 待确认金额
                        let amountToBeConfirmed
                        item.amountToBeConfirmed == undefined || item.amountToBeConfirmed === '' ? 
                            amountToBeConfirmed = '/' :
                            amountToBeConfirmed = (+item.amountToBeConfirmed).toFixed(2)

                        // 欠款
                        let debtMoney
                        if (item.needPay == undefined || item.sumPay == undefined) {
                            debtMoney = 0
                        } else {
                            debtMoney = (item.needPay - item.sumPay).toFixed(2)
                        }
                        // 核销数 ，未核销数
                        let sumEstablishQuantity, unEstablishQuantity
                        if (item.sumEstablishQuantity == undefined || item.sumEstablishQuantity === '') {
                            sumEstablishQuantity = '/'
                            unEstablishQuantity = '/'
                        } else {
                            sumEstablishQuantity = item.sumEstablishQuantity
                            unEstablishQuantity = item.orderPurchaseQuantity - item.sumEstablishQuantity
                        }
                        // 退货数量
                        let returnQuantity
                        if(item.returnQuantity == undefined || item.returnQuantity === '') {
                            returnQuantity = '/'
                        } else {
                            returnQuantity = item.returnQuantity
                        }
                        return {
                            ...item,
                            amountToBeConfirmed,
                            debtMoney,
                            sumEstablishQuantity,
                            unEstablishQuantity,
                            returnQuantity,
                            mallItemFileUrl
                        }
                    })
                    this.total = parseInt(res.data.totalCount)
                } else {
                    this.$message.error(res.errorMsg || '获取列表数据失败')
                }
            }).catch(err=> {
                this.loading = false
                console.log(err)
            })
        },
        searchHandle() {
            this.currentPage = 1
            this.curRoutePush()
        },
        toClearDetail(row) {
            this.$router.push('/supplier/order/detail-clear?orderId=' + row.order_id)
        },
        indexMethod(index) {
            return this.total - this.pageSize * (this.currentPage-1) - index;
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.curRoutePush()
        },
        curRoutePush() {
            this.$router.push('/supplier/goods/list?search=' + this.searchWords + 
            '&page=' + this.currentPage + 
            '&size=' + this.pageSize).catch(err => {err})
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.curRoutePush()
        },

        toListLock() {
            this.$router.push('/supplier/order/list-lock')
        },
        toListOrder() {
            this.$router.push('/supplier/order/list-order')
        },
    },
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px;
  min-width: 900px;
}
.header-handle {
    margin-top: 24px;
    padding: 20px 24px;
    height: 28px;
    background: #fff;
    .cg-search-box {
        float: left;
    }
    .btns {
        float: right;
    }
}
.table-wrap {
    margin-top: 8px
}
.el-image {
    display: block;
}
</style>